import { HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { HttpService } from "./http.service";
import { CampPatientnotes } from "../../../interfaces/masters/camp-patientnotes";
import { Injectable } from "@angular/core";

@Injectable()
export class CampPatientnotesApi {
    private readonly apiController: string = 'campPateintnotes';

    constructor(private api: HttpService) { }

  list(url: string, options?: any): Observable<any[]> {
  
    const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
    return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
  }

  getById(url : string, options?: any): Observable<CampPatientnotes> {
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.directGet(url,header);
  }

  add(url:string, data: any):Observable<any[]>{
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.post( url, data, header);
  }

  update(url:string, data: CampPatientnotes):Observable<any>{
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.directPut( url, data, {headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
  }
  
  searchList(url: string, data:any, options?: any): Observable<any[]> {
    const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
    return this.api.post(url,data,{headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
  }
  
  delete(url: string):Observable<any>{
    return this.api.directDelete(url);
  }
}
